import { TYPE_PERSONNE } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case TYPE_PERSONNE.PARTICULIER:
        return 'Particulier';
      case TYPE_PERSONNE.PROFESSIONNEL_RECEPTION:
        return 'Professionnel de la réception';
      case TYPE_PERSONNE.SYNDIC_BAILLEUR:
        return 'Syndic ou bailleur';
      case TYPE_PERSONNE.ELU:
        return 'Élu';
      case TYPE_PERSONNE.JOURNALISTE:
        return 'Journaliste';
      case TYPE_PERSONNE.AUTRE:
        return 'Autre';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/base/filters/type-personne.filter.js